'use client';

import {BaseError} from '@components/BaseError';
import {useSignOut} from '@hooks/useSignOut';

const Forbidden = () => {
  const signOut = useSignOut();

  return (
    <BaseError
      heading="You don't have access"
      description="You don't have permission to view this page. Contact your administrator to request access."
      button={{text: 'Log out', handleBack: signOut}}
    />
  );
};

export default Forbidden;
